/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   hook to return routeProps
 */

import { RoutesContext, getMatchForPath } from '@zcode/router-utils'
import { useContext, useMemo } from 'react'
import {
  type match,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom'

import type { History, Location } from 'history'

interface useRoutePropsResult {
  history: History
  location: Location
  match: match
}

/**
 * @deprecated Use react-router hooks within functional components instead.
 */
export const useRouteProps = (): useRoutePropsResult => {
  const location = useLocation()
  const history = useHistory()

  const routes = useContext(RoutesContext)

  const existingMatch = useRouteMatch()
  const routeMatch =
    getMatchForPath(routes, location, existingMatch.path) || existingMatch

  return useMemo(
    () => ({ history, location, match: routeMatch }),
    [history, location, routeMatch]
  )
}
